import { render } from "./PendukungView.vue?vue&type=template&id=4180c6ab"
import script from "./PendukungView.vue?vue&type=script&lang=js"
export * from "./PendukungView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__